import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  button: {
    cursor: "pointer",
  },
  deleteButton: {
    color: "#F04438",
  },
}));

export default styles;
